export const environment = {
  production: false,
  apiUrl: 'https://apps-test.magiis.com/magiis-v0.2/',
  webExternalUrl: 'https://apps-test.magiis.com/#/external',
  publicApiUrl: 'https://apps-test.magiis.com/magiis-public/',
  traslatorApiUrl: 'https://translate.yandex.net/api/v1.5/tr.json/translate',
  notificationsApiUrl: 'https://apps-test.magiis.com/mmc-0.0.1/',
  firebase: {
    apiKey: "AIzaSyDQ-VAOwkYtIsFqZ5yrgqMuG4QCSNSopG0",
    authDomain: "magiis-test.firebaseapp.com",
    databaseURL: "https://magiis-test.firebaseio.com",
    projectId: "magiis-test",
    storageBucket: "magiis-test.appspot.com",
    messagingSenderId: "194422159129"
  },
   mailchimp: {
    login_uri: "https://login.mailchimp.com/oauth2/authorize?response_type=code&client_id=761052906819",
    applications_uri: "https://us7.admin.mailchimp.com/account/api/"
  },
  googleApiKey: 'AIzaSyBCZ3H_CIeETd7mPzAXQ4Hiqpf6976sMAs',
  googleRecaptchaKey : '6Ld3Tt0UAAAAALTjOBQ6YbwenI00-00DZcTIPz_R',
  mercadoPagoApiKey: 'TEST-fad752e2-fd61-487f-a0de-fc9b94bba7f0',
  mercadoPagoRedirectUri: 'https://auth.mercadopago.com.ar/authorization?client_id=599184990104450&response_type=code&platform_id=mp&redirect_uri=https%3A%2F%2Fapps-test.magiis.com%2Fhome%2Fcarrier%2Fintegrations%2Fmercadopago',
  mercadoPagoApplicationsUri: 'https://www.mercadopago.com.ar/account/security/applications/connections',
  mercadoPago: {
    "AR": {
      mercadoPagoApiKey: 'TEST-a4cdcfa3-c4cc-415b-9c2c-f0170bd80d6f',
      mercadoPagoRedirectUri: 'https://auth.mercadopago.com.ar/authorization?client_id=360342602104326&response_type=code&platform_id=mp&redirect_uri=https%3A%2F%2Fapps-test.magiis.com%2Fhome%2Fcarrier%2Fintegrations%2Fmercadopago',
      mercadoPagoApplicationsUri: 'https://www.mercadopago.com.ar/account/security/applications/connections',
    },
    "CO": {
      mercadoPagoApiKey: 'TEST-64d7af77-a27b-4008-85d0-44cecdc402e5',
      mercadoPagoRedirectUri: 'https://auth.mercadopago.com.co/authorization?client_id=1506937819972917&response_type=code&platform_id=mp&redirect_uri=https%3A%2F%2Fapps-test.magiis.com%2Fhome%2Fcarrier%2Fintegrations%2Fmercadopago',
      mercadoPagoApplicationsUri: 'https://www.mercadopago.com.co/account/security/applications/connections',
    },
    "PE": {
      mercadoPagoApiKey: 'TEST-c328b828-3f75-478a-9e93-c2dd20cc8f54',
      mercadoPagoRedirectUri: 'https://auth.mercadopago.com.pe/authorization?client_id=2259644575126282&response_type=code&platform_id=mp&redirect_uri=https%3A%2F%2Fapps-test.magiis.com%2Fhome%2Fcarrier%2Fintegrations%2Fmercadopago',
      mercadoPagoApplicationsUri: 'https://www.mercadopago.com.pe/account/security/applications/connections',
    }
  },
  stripeRedirectUri: 'https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_KMfl06SoQqAaqnXVcywpXTwmsgnJRZDg&scope=read_write',
  stripeApplicationsUri: 'https://dashboard.stripe.com/account/applications',
  qrcodeLink: 'https://magiistest.page.link/newuser',
  cryptoJsKey: 'MAGIISCARRIER$Secure&Key#2025!',
};
